<div class="flex justify-between px-6 pt-6">
    <div class="flex items-center gap-3">
        <p class="text-xl text-[#0A0A0A] font-bold">Enter your display name and email</p>
    </div>

    <img
        src="/assets/images/shared/cross-black-icon.svg"
        alt="Close"
        class="h-6 w-6 cursor-pointer"
        (click)="onCancel()" />
</div>

<mat-dialog-content>
    <form class="space-y-4" [formGroup]="infoForm">
        <div class="flex flex-col space-y-2">
            <label for="displayName" class="text-xs text-[#0A0A0A] font-semibold uppercase">Display Name</label>
            <input
                id="displayName"
                formControlName="displayName"
                placeholder="Display Name"
                class="w-full form-field-container" />
            @if (infoForm.controls.displayName.touched && infoForm.controls.displayName.hasError('required')) {
                <div class="text-red-500 text-[0.625rem]">Display name is required.</div>
            }
        </div>
        <div class="flex flex-col space-y-2">
            <label for="email" class="text-xs text-[#0A0A0A] font-semibold uppercase">Email Address</label>
            <input
                type="email"
                id="email"
                formControlName="email"
                placeholder="Your@email.com"
                class="w-full form-field-container" />
            @if (infoForm.get('email')?.touched && infoForm.get('email')?.errors) {
                @if (infoForm.get('email')?.errors?.['required']) {
                    <div class="text-red-500 text-[0.625rem]">Email Address is required.</div>
                } @else if (infoForm.get('email')?.errors?.['pattern']) {
                    <div class="text-red-500 text-[0.625rem]">Please enter a valid email.</div>
                }
            }
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions class="flex justify-between gap-3">
    <button type="button" class="white-border-button flex-1 py-4 rounded-full" (click)="onCancel()">Close</button>
    <button type="button" class="border-button flex-1 py-4 rounded-full" (click)="onSubmit()">
        <p>Complete</p>
    </button>
</mat-dialog-actions>
